import { render, staticRenderFns } from "./Views.vue?vue&type=template&id=1a1a51c2&scoped=true"
import script from "./Views.vue?vue&type=script&lang=js"
export * from "./Views.vue?vue&type=script&lang=js"
import style0 from "./Views.vue?vue&type=style&index=0&id=1a1a51c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a51c2",
  null
  
)

export default component.exports